import src from "IMAGE";
export default { src, width: 176, height: 35, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAPElEQVR42i3HsQnAIAAF0ZshTWZIFEG0cgXBQp1ES5f3CxaP45iB+T8k4JMoXpwYsazECC9ZU6RJve2nG9hoBkxh7Pl9AAAAAElFTkSuQmCC"};
